import { cmyk } from 'pdf-lib';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('ttIeHttpSrcBridge', {
        template: `<img ie-http-src="{{vm.imageUrl}}" ie-application-id="vm.applicationId" style="height: 100%; width: 100%;"/>`,
        controllerAs: 'vm',
        bindings: {
            imageUrl: '<',
            applicationId: '<?',
        },
        controller: [
            'fileService',
            function (fileService) {
                const vm = this;

                vm.$onInit = async function () {
                    if (!vm.applicationId) {
                        vm.applicationId = fileService.applicationId;
                    }
                };
            },
        ],
    });
})();
